import React from 'react';
import Select, { components } from 'react-select';
import makeAnimated from 'react-select/animated';
import '../../assets/scss/multi-select.scss';
const animatedComponents = makeAnimated();

const Option = (props) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
      />{' '}
      <label>{props.label}</label>
    </components.Option>
  );
};

const customStyle = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? 'transparent' : 'transparent',
    color: 'black',
    ':hover': {
      backgroundColor: '#f0f0f0',
    },
  }),
};

const MultiSelect = (props) => {
  const { designType } = props;

  return (
    <Select className="multi-select-component multi_tick_checkbox"
      closeMenuOnSelect={props.closeMenuOnSelect}
      components={(designType === 'checkbox') ? { animatedComponents, Option } : { animatedComponents }}
      defaultValue={props.defaultValue}
      isMulti={props.isMulti}
      isClearable={props.isClearable}
      placeholder={`Select ${props.placeholder}`}
      value={props.selectedOptions}
      options={props.options}
      hideSelectedOptions={(designType === 'checkbox') ? false : true}
      styles={(designType === 'checkbox') ? customStyle : ''}
      onChange={props.onChange}
      classNamePrefix="multibox" 
    />
  )
};

export default MultiSelect;
